import { render, staticRenderFns } from "./AreaNotesTable.vue?vue&type=template&id=28d56c88&scoped=true"
import script from "./AreaNotesTable.vue?vue&type=script&lang=ts"
export * from "./AreaNotesTable.vue?vue&type=script&lang=ts"
import style0 from "./AreaNotesTable.vue?vue&type=style&index=0&id=28d56c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d56c88",
  null
  
)

export default component.exports